import { render, staticRenderFns } from "./programAreaOverview.vue?vue&type=template&id=fd14fcaa"
import script from "./programAreaOverview.vue?vue&type=script&lang=js"
export * from "./programAreaOverview.vue?vue&type=script&lang=js"
import style0 from "./programAreaOverview.vue?vue&type=style&index=0&id=fd14fcaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports